<template>
  <rental-delivery type-vue="create" type-mission="livraison" />
</template>

<script>
import RentalDelivery from '@/components/driver/rentalCoupon/RentalDelivery';

export default {
  name: 'RentalDeliveryCreate',
  components: { RentalDelivery },
};
</script>
